module.exports = __webpack_public_path__ + "static/media/ImgExcel2.16c01b4d.svg";